import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Ireland (1-63)
import ireland1 from '../images/Ireland1.jpeg';
import ireland2 from '../images/Ireland2.jpeg';
import ireland3 from '../images/Ireland3.jpeg';
import ireland4 from '../images/Ireland4.jpeg';
import ireland5 from '../images/Ireland5.jpeg';
import ireland6 from '../images/Ireland6.jpeg';
import ireland7 from '../images/Ireland7.jpeg';
import ireland8 from '../images/Ireland8.jpeg';
import ireland9 from '../images/Ireland9.jpeg';
import ireland10 from '../images/Ireland10.jpeg';
import ireland11 from '../images/Ireland11.jpeg';
import ireland12 from '../images/Ireland12.jpeg';
import ireland13 from '../images/Ireland13.jpeg';
import ireland14 from '../images/Ireland14.jpeg';
import ireland15 from '../images/Ireland15.jpeg';
import ireland16 from '../images/Ireland16.jpeg';
import ireland17 from '../images/Ireland17.jpeg';
import ireland18 from '../images/Ireland18.jpeg';
import ireland19 from '../images/Ireland19.jpeg';
import ireland20 from '../images/Ireland20.jpeg';
import ireland21 from '../images/Ireland21.jpeg';
import ireland22 from '../images/Ireland22.jpeg';
import ireland23 from '../images/Ireland23.jpeg';
import ireland24 from '../images/Ireland24.jpeg';
import ireland25 from '../images/Ireland25.jpeg';
import ireland26 from '../images/Ireland26.jpeg';
import ireland27 from '../images/Ireland27.jpeg';
import ireland28 from '../images/Ireland28.jpeg';
import ireland29 from '../images/Ireland29.jpeg';
import ireland30 from '../images/Ireland30.jpeg';
import ireland31 from '../images/Ireland31.jpeg';
import ireland32 from '../images/Ireland32.jpeg';
import ireland33 from '../images/Ireland33.jpeg';
import ireland34 from '../images/Ireland34.jpeg';
import ireland35 from '../images/Ireland35.jpeg';
import ireland36 from '../images/Ireland36.jpeg';
import ireland37 from '../images/Ireland37.jpeg';
import ireland38 from '../images/Ireland38.jpeg';
import ireland39 from '../images/Ireland39.jpeg';
import ireland40 from '../images/Ireland40.jpeg';
import ireland41 from '../images/Ireland41.jpeg';
import ireland42 from '../images/Ireland42.jpeg';
import ireland43 from '../images/Ireland43.jpeg';
import ireland44 from '../images/Ireland44.jpeg';
import ireland45 from '../images/Ireland45.jpeg';
import ireland46 from '../images/Ireland46.jpeg';
import ireland47 from '../images/Ireland47.jpeg';
import ireland48 from '../images/Ireland48.jpeg';
import ireland49 from '../images/Ireland49.jpeg';
import ireland50 from '../images/Ireland50.jpeg';
import ireland51 from '../images/Ireland51.jpeg';
import ireland52 from '../images/Ireland52.jpeg';
import ireland53 from '../images/Ireland53.jpeg';
import ireland54 from '../images/Ireland54.jpeg';
import ireland55 from '../images/Ireland55.jpeg';
import ireland56 from '../images/Ireland56.jpeg';
import ireland57 from '../images/Ireland57.jpeg';
import ireland58 from '../images/Ireland58.jpeg';
import ireland59 from '../images/Ireland59.jpeg';
import ireland60 from '../images/Ireland60.jpeg';
import ireland61 from '../images/Ireland61.jpeg';
import ireland62 from '../images/Ireland62.jpeg';
import ireland63 from '../images/Ireland63.jpeg';

function Ireland() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    ireland1, ireland2, ireland3, ireland4, ireland5, ireland6, ireland7, ireland8, ireland9, ireland10,
    ireland11, ireland12, ireland13, ireland14, ireland15, ireland16, ireland17, ireland18, ireland19, ireland20,
    ireland21, ireland22, ireland23, ireland24, ireland25, ireland26, ireland27, ireland28, ireland29, ireland30,
    ireland31, ireland32, ireland33, ireland34, ireland35, ireland36, ireland37, ireland38, ireland39, ireland40,
    ireland41, ireland42, ireland43, ireland44, ireland45, ireland46, ireland47, ireland48, ireland49, ireland50,
    ireland51, ireland52, ireland53, ireland54, ireland55, ireland56, ireland57, ireland58, ireland59, ireland60,
    ireland61, ireland62, ireland63
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇮🇪 Ireland 2022 🇮🇪</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Ireland ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Ireland;